import React, { useState } from "react";
import classNames from "classnames";
import { Col, Row } from "react-bootstrap";
import Textfield from "@app/components/Textfield";
import Button from "@app/components/Button";
import Modal from "@app/components/Modal";
import * as styles from "./FilterSearchSortHead.module.scss";
import * as stylesRadioHelper from "@app/components/RadioHelper/RadioHelper.module.scss";
import * as stylesRadioSwitcher from "@app/components/RadioSwitcher/RadioSwitcher.module.scss";
import * as stylesSelect from "@app/components/Select/Select.module.scss";
import Sort from "@app/components/Sort";
import ReactSelect from "react-select";
import Icon from "@app/components/Icon";

const FilterSearchSortHead = ({ onSearch, onSort, onFilter, filters, filtersCount, sort, resultsCount, onOrder }) => {
	const FilterSearchSortHeadClassName = classNames({
		[styles["filter-search-sort-head"]]: true,
	});
	const [showFilters, setShowFilters] = useState(false);

	return (
		<>
			<Row className={"mb-12"}>
				<Col>
					<div className={styles["search-container"]}>
						<Textfield
							className={styles["search-field"]}
							name={"search"}
							onChange={(e) => onSearch(e?.target?.value)}
							placeholder={"z.B. Kunde, Kundennr. & Beruf"}
						/>
						<Icon icon={"search"} size={24} className={styles["search-icon"]} />
					</div>
				</Col>
			</Row>
			<Row className={"mb-24"}>
				<Col xs={6}>
					<Button
						className={styles["filter-button"]}
						label={`Filtern nach ${filtersCount > 0 ? `(${filtersCount})` : ""}`}
						type={"quaternary"}
						callback={() => {
							setShowFilters(true);
						}}
						small={true}
					/>
					<Modal
						show={showFilters}
						hasCloseButton={true}
						onHide={() => setShowFilters(false)}
						buttons={[
							<Button
								label={"Schließen"}
								callback={() => {
									setShowFilters(false);
								}}
							/>,
						]}
					>
						<form
							onChange={(e) => {
								const formData = new FormData(e.currentTarget);
								const values = Object.fromEntries(formData.entries());
								console.log(values);
								onFilter(values);
							}}
						>
							<div className="radio-switcher-container">
								<p className={"mb-6"}>Aktive Einsätze</p>
								<div>
									{[
										{ label: "Alle", value: "all" },
										{ label: "Aktive", value: "active" },
										{ label: "Inaktive", value: "inactive" },
									].map(({ label, value }) => (
										<div className={stylesRadioHelper["radio-helper"]}>
											<label
												htmlFor={`filter-active-${value}`}
												className={classNames(stylesRadioSwitcher["radio-switcher"], {
													[stylesRadioSwitcher["is-active"]]:
														filters["filter-active"] === value,
												})}
											>
												<div className={stylesRadioSwitcher.content}>{label}</div>
											</label>
											<input
												type="radio"
												id={`filter-active-${value}`}
												name="filter-active"
												value={value}
												defaultChecked={filters["filter-active"] === value}
											/>
										</div>
									))}
								</div>
							</div>
							<div className={classNames("radio-switcher-container", "mt-18")}>
								<p className={"mb-6"}>Art der Besichtigung</p>
								<div>
									{[
										{ label: "Alle", value: "all" },
										{ label: "Erstbesichtigung", value: "initial" },
										{ label: "Folgebeschichtung", value: "follow_up" },
									].map(({ label, value }) => (
										<div className={stylesRadioHelper["radio-helper"]}>
											<label
												htmlFor={`filter-inspection-type-${value}`}
												className={classNames(stylesRadioSwitcher["radio-switcher"], {
													[stylesRadioSwitcher["is-active"]]:
														filters["filter-inspection-type"] === value,
												})}
											>
												<div className={stylesRadioSwitcher.content}>{label}</div>
											</label>
											<input
												type="radio"
												id={`filter-inspection-type-${value}`}
												name="filter-inspection-type"
												value={value}
												defaultChecked={filters["filter-inspection-type"] === value}
											/>
										</div>
									))}
								</div>
							</div>
						</form>
					</Modal>
				</Col>
				<Col xs={6} className={"d-flex justify-content-end"}>
					<div className={classNames(styles["order-button"])}>
						<div className={stylesSelect["select"]}>
							<ReactSelect
								name={"sort"}
								options={[
									{ label: "Erstellungsdatum", value: "visitDate" },
									{ label: "Fälligkeitsdatum", value: "dueDate" },
									{ label: "Kundenname", value: "customerName" },
									{ label: "Kundenummer", value: "customerId" },
									{ label: "Tätigkeit", value: "job" },
								]}
								placeholder={"Sortieren nach"}
								classNamePrefix={"react-select"}
								isSearchable={false}
								theme={(theme) => ({
									...theme,
									borderRadius: 0,
									colors: {
										primary: "#fff",
									},
								})}
								value={sort.value}
								onChange={(value) => {
									onSort(value);
								}}
							/>
						</div>
					</div>
				</Col>
			</Row>
			<Row className={`mb-18`}>
				<Col xs={12}>
					<Sort
						count={resultsCount}
						countLabel={"Ergebnisse"}
						label={sort.label}
						desc={true}
						onClick={onOrder}
					/>
				</Col>
			</Row>
		</>
	);
};

FilterSearchSortHead.propTypes = {};

export default FilterSearchSortHead;
